import {
  FaFile,
  FaRegFileImage,
  FaRegFilePdf,
  FaRegFileWord,
} from "react-icons/fa";

import { colors } from "../styles/colors";
import { DocumentType } from "../constants/DocumentUpload";

export const getDocTypeIcon = (type: DocumentType) => {
  const iconSize = "1rem";
  const color = colors.primary.main;
  switch (type) {
    case DocumentType.INVALID:
      return <FaFile size={iconSize} color={color} />;
    case DocumentType.DOC:
    case DocumentType.DOCX:
      return <FaRegFileWord size={iconSize} color={color} />;
    case DocumentType.PDF:
      return <FaRegFilePdf size={iconSize} color={color} />;
    case DocumentType.JPEG:
    case DocumentType.PNG:
    case DocumentType.JPG:
      return <FaRegFileImage size={iconSize} color={color} />;
    default:
      return <FaFile size={iconSize} color={color} />;
  }
};
